module.exports = __webpack_public_path__ + "static/media/zheng1-4.8b28ab19.png";